import React, { useContext, useEffect } from 'react';

import { Navbar, BottomNavbar, Footer, Sidebar } from '../../components';
import Items from '../Item/Items';

import { useStateContext } from '../../context/ContextProvider';
import ItemContext from '../../context/item/itemContext';



const Home = () => {
  const {
    setCurrentColor,
    setCurrentMode,
    currentMode,
    activeMenu,
  } = useStateContext();

  const itemContext = useContext(ItemContext);
  const { getPublicItems } = itemContext;


  useEffect(() => {
    getPublicItems();

    const currentThemeColor = localStorage.getItem('colorMode');
    const currentThemeMode = localStorage.getItem('themeMode');

    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
      <div className="flex relative dark:bg-main-dark-bg">

        {activeMenu ? (
          <div className="w-52 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
            <Sidebar />
          </div>
        ) : (
          <div className="w-0 dark:bg-secondary-dark-bg">
            <Sidebar />
          </div>
        )}
        <div
          className={
            activeMenu
              ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-52 w-full  '
              : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 '
          }
        >
          <div className="sticky  md:static bg-main-bg dark:bg-main-dark-bg navbar w-full ">
            <Navbar />
            <BottomNavbar />
          </div>
          <div>
            <Items />
          </div>
          <Footer />
        </div>
      </div>

    </div>
  );
};

export default Home;
